import React from "react";


export default function Switch({ checked, onChange }) {
    return (
        <div
            className={`status-switch ${checked ? "active" : "inactive"}`}
            onClick={onChange}
        >
            <div className="status-slider"></div>
        </div>
    );
}